import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { advisorHeaders } from "../lib/clarity";

const RANGES = [[7, "7 days"], [30, "30 days"], [0, "All time"]];
const pct = (v) => (v == null ? "—" : `${v}%`);

export const SignupFunnel = () => {
  const [days, setDays] = useState(7);
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/admin/retention/signup-funnel?days=${days}`, advisorHeaders()).then((r) => setD(r.data)).catch(() => setD(null));
  }, [days]);

  return (
    <section data-testid="signup-funnel" className="mt-12">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-4">
        <div>
          <h2 className="font-display text-2xl">Sign-up funnel · per tool</h2>
          <p className="text-xs text-exodus-muted mt-1">Unique guests who opened the sign-up screen vs. finished creating access.</p>
        </div>
        <div className="flex gap-1">
          {RANGES.map(([v, l]) => (
            <button key={v} data-testid={`signup-funnel-range-${v}`} onClick={() => setDays(v)}
              className={`text-[11px] px-3 py-1.5 border transition-colors ${days === v ? "border-exodus-gold bg-exodus-gold text-black" : "border-exodus-border text-exodus-muted hover:border-exodus-gold"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="border border-exodus-border overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead className="bg-exodus-elevated"><tr className="text-left text-[10px] uppercase tracking-widest text-exodus-muted">
            <th className="p-3">Tool</th><th className="p-3">Opened sign-up</th><th className="p-3">Completed</th><th className="p-3">Conversion</th>
          </tr></thead>
          <tbody>
            {d?.items.map((r) => (
              <tr key={r.tool} data-testid={`signup-funnel-row-${r.tool}`} className="border-t border-exodus-border">
                <td className="p-3">{r.label}</td>
                <td className="p-3">{r.opened}</td>
                <td className="p-3">{r.completed}</td>
                <td className="p-3 gold-text">{pct(r.conversion)}</td>
              </tr>
            ))}
            {d && (
              <tr data-testid="signup-funnel-total" className="border-t border-exodus-gold/40 font-medium">
                <td className="p-3">All tools</td><td className="p-3">{d.total_opened}</td><td className="p-3">{d.total_completed}</td><td className="p-3 gold-text">{pct(d.total_conversion)}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};
